<script setup lang="ts">
import { Star } from 'lucide-vue-next'
</script>

<template>
  <div class="space-y-6">
    <div class="text-center py-12 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl">
      <Star class="w-16 h-16 text-yellow-500 fill-yellow-500 mx-auto mb-4" />
      <h3 class="text-2xl font-bold text-gray-900 mb-2">Student Reviews</h3>
      <p class="text-gray-500 mt-2">Reviews are coming soon. Stay tuned!</p>
    </div>
  </div>
</template>
